export const menuToRoutePath = {
  "MENU-001": "/dashboard",
};
